<ng-container *ngIf="isInlineAction; else alertLayout">
  <div class="snackbar-container snackbar-container--inline-action">
    <span class="snackbar-container__message">{{ data.title | translate }}</span>
    <button
      *ngIf="data.action"
      mat-button
      color="accent"
      type="button"
      class="snackbar-container__action-button"
      (click)="onActionClick()"
    >
      {{ data.action | translate }}
    </button>
    <button
      *ngIf="data.dismissible"
      type="button"
      class="snackbar-container__close"
      [attr.aria-label]="'button.close' | translate"
      (click)="onCloseClick()"
    >
      <i class="ri-close-fill" aria-hidden="true"></i>
    </button>
  </div>
</ng-container>

<ng-template #alertLayout>
  <div class="snackbar-container">
    <i *ngIf="data.icon" class="{{ data.icon }} snackbar-container__icon" aria-hidden="true"></i>
    <span class="snackbar-container__text">
      <ng-container *ngIf="data.message; else titleOnly">
        <strong class="snackbar-container__lead">{{ data.title | translate }}</strong>
        <span class="snackbar-container__detail">{{ data.message | translate }}</span>
      </ng-container>
      <ng-template #titleOnly>{{ data.title | translate }}</ng-template>
    </span>
    <button
      *ngIf="data.action"
      type="button"
      class="snackbar-container__action"
      (click)="onActionClick()"
    >
      {{ data.action | translate }}
    </button>
  </div>
</ng-template>
